import React, { useState } from "react";
import TicketMain from "../../Components/layouts/Ticket/TicketMain";
import { BtnPrimary } from "../../Components/share/buttons/Btn";
import EmptyCourseDash from "../../Components/share/EmptyCourseDash/EmptyCourseDash";
import { Modal } from "../../Components/share/modal/Modal";
import TicketModal from "../../Components/layouts/AdminDashboard/TicketModal";

const Ticket = () => {
  const [list, setList] = useState(["1"]);
  const [newSurvey, setNewSurvey] = useState(false);
  return (
    <div>
      <div>
        {list.length === 0 ? (
          <EmptyCourseDash name="تخفیف " show={setNewSurvey} />
        ) : (
          <div>
            <TicketMain show={setNewSurvey}/>
          </div>
        )}
        <Modal show={newSurvey}>
          <TicketModal close={setNewSurvey} />
        </Modal>
      </div>
    </div>
  );
};

export default Ticket;
